import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://bssyrtvkoqkkkkpnyvqh.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_l1PZHZOUCY85KvdEEkBcyg_LJ_dSzi9';

// Single source for the backend location — every page imports these instead of
// hardcoding the project URL, so switching projects is one env change.
export const SUPABASE_URL = supabaseUrl;
export const SUPABASE_ANON_KEY = supabaseAnonKey;
export const FUNCTIONS_URL = `${supabaseUrl}/functions/v1`;

const fetchWithTimeout = (url, options) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort('Request timed out'), 30000);
  const { signal: _ignored, ...rest } = options || {};
  return fetch(url, { ...rest, signal: controller.signal }).finally(() => clearTimeout(timeoutId));
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: { fetch: fetchWithTimeout },
});
